import React from 'react';
import useChatLogic from '../../hooks/useChatLogic';
import ChatWindow from './ChatWindow';
import ChatInput from './ChatInput';
import Logo from '../Logo/Logo';
import ResetButton from '../ResetButton/ResetButton';
import WordSuggestion from '../WordSuggestion/WordSuggestion';
import SystemInfo from '../SystemInfo/SystemInfo';
import PersonalitySelector from '../PersonalitySelector/PersonalitySelector';
import Background from '../App/Background';

import '../../styles/logo.scss';
import '../../styles/main.scss';
import '../../styles/input.scss';
import '../../styles/chat.scss';
import '../../styles/markdown.scss';
import '../../styles/system.scss';
import '../../styles/suggestion.scss';
import '../../styles/background.scss';
import '../../styles/personality.scss';
import '../../styles/responsive.scss';

function ChatComponent() {
  const {
    prompt,
    setPrompt,
    conversation,
    isLoading,
    inputRef,
    suggestions,
    selectedWord,
    selectedPersonality,
    handleSubmit,
    reset,
    handleSelectWord,
    handlePersonalityChange,
    debouncedFetchSuggestions,
    setSuggestions,
  } = useChatLogic();

  return (
    <>
      <Background />
      <div className="window-component">
        <div className="header-container">
          <Logo />
          {conversation.length > 0 && <ResetButton reset={reset} />}
        </div>
        <div className={'chat-container' + (conversation.length === 0 ? ' empty' : ' animate')}>
          <ChatWindow
            conversation={conversation}
            isLoading={isLoading}
            selectedPersonality={selectedPersonality}
            onPersonalityChange={handlePersonalityChange}
            showPersonalityTabs={conversation.length > 0}
          />
          <div className="chat-input-body">
            <div className="chat-input-row">
              {conversation.length === 0 && (
                <PersonalitySelector
                  selectedPersonality={selectedPersonality}
                  onPersonalityChange={handlePersonalityChange}
                  disabled={isLoading}
                />
              )}
              <ChatInput
                prompt={prompt}
                setPrompt={setPrompt}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                isReply={conversation.length > 0}
                inputRef={inputRef}
                debouncedFetchSuggestions={debouncedFetchSuggestions}
                selectedWord={selectedWord}
                setSuggestions={setSuggestions}
              />
            </div>
            <WordSuggestion
              suggestions={suggestions}
              onSelectWord={handleSelectWord}
            />
          </div>
        </div>
        <SystemInfo />
      </div>
    </>
  );
}

export default ChatComponent;